var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66663 1.04169C7.0118 1.04169 7.29163 1.32151 7.29163 1.66669V4.16669C7.29163 4.51186 7.0118 4.79169 6.66663 4.79169C6.32145 4.79169 6.04163 4.51186 6.04163 4.16669V1.66669C6.04163 1.32151 6.32145 1.04169 6.66663 1.04169Z",
    fill: "#45A9EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3334 1.04169C13.6786 1.04169 13.9584 1.32151 13.9584 1.66669V4.16669C13.9584 4.51186 13.6786 4.79169 13.3334 4.79169C12.9882 4.79169 12.7084 4.51186 12.7084 4.16669V1.66669C12.7084 1.32151 12.9882 1.04169 13.3334 1.04169Z",
    fill: "#45A9EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1667 13.125C14.0391 13.125 13.125 14.0391 13.125 15.1667C13.125 16.2943 14.0391 17.2083 15.1667 17.2083C16.2942 17.2083 17.2083 16.2943 17.2083 15.1667C17.2083 14.0391 16.2942 13.125 15.1667 13.125ZM11.875 15.1667C11.875 13.3487 13.3487 11.875 15.1667 11.875C16.9846 11.875 18.4583 13.3487 18.4583 15.1667C18.4583 16.9846 16.9846 18.4583 15.1667 18.4583C13.3487 18.4583 11.875 16.9846 11.875 15.1667Z",
    fill: "#45A9EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0581 17.0581C17.3021 16.814 17.6979 16.814 17.9419 17.0581L18.7753 17.8914C19.0194 18.1355 19.0194 18.5312 18.7753 18.7753C18.5312 19.0194 18.1355 19.0194 17.8914 18.7753L17.0581 17.9419C16.814 17.6979 16.814 17.3021 17.0581 17.0581Z",
    fill: "#45A9EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.29163 7.57501C2.29163 7.22983 2.57145 6.95001 2.91663 6.95001H17.0833C17.4285 6.95001 17.7083 7.22983 17.7083 7.57501C17.7083 7.92019 17.4285 8.20001 17.0833 8.20001H2.91663C2.57145 8.20001 2.29163 7.92019 2.29163 7.57501Z",
    fill: "#45A9EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94758 4.4878C3.41364 5.06281 3.125 5.92916 3.125 7.08335V14.1667C3.125 15.3209 3.41364 16.1872 3.94758 16.7622C4.47373 17.3289 5.32746 17.7084 6.66667 17.7084H11.1417C11.4868 17.7084 11.7667 17.9882 11.7667 18.3334C11.7667 18.6785 11.4868 18.9584 11.1417 18.9584H6.66667C5.08921 18.9584 3.8596 18.5045 3.03159 17.6128C2.21136 16.7295 1.875 15.5125 1.875 14.1667V7.08335C1.875 5.73754 2.21136 4.52056 3.03159 3.63724C3.8596 2.74553 5.08921 2.29169 6.66667 2.29169H13.3333C14.9108 2.29169 16.1404 2.74553 16.9684 3.63724C17.7886 4.52056 18.125 5.73754 18.125 7.08335V10.8334C18.125 11.1785 17.8452 11.4584 17.5 11.4584C17.1548 11.4584 16.875 11.1785 16.875 10.8334V7.08335C16.875 5.92916 16.5864 5.06281 16.0524 4.4878C15.5263 3.92117 14.6725 3.54169 13.3333 3.54169H6.66667C5.32746 3.54169 4.47373 3.92117 3.94758 4.4878Z",
    fill: "#45A9EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16284 11.4167C9.16284 10.9565 9.53594 10.5834 9.99618 10.5834H10.0037C10.4639 10.5834 10.837 10.9565 10.837 11.4167C10.837 11.8769 10.4639 12.25 10.0037 12.25H9.99618C9.53594 12.25 9.16284 11.8769 9.16284 11.4167Z",
    fill: "#45A9EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07861 11.4167C6.07861 10.9565 6.45171 10.5834 6.91195 10.5834H6.91943C7.37967 10.5834 7.75276 10.9565 7.75276 11.4167C7.75276 11.8769 7.37967 12.25 6.91943 12.25H6.91195C6.45171 12.25 6.07861 11.8769 6.07861 11.4167Z",
    fill: "#45A9EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07861 13.9167C6.07861 13.4564 6.45171 13.0833 6.91195 13.0833H6.91943C7.37967 13.0833 7.75276 13.4564 7.75276 13.9167C7.75276 14.3769 7.37967 14.75 6.91943 14.75H6.91195C6.45171 14.75 6.07861 14.3769 6.07861 13.9167Z",
    fill: "#45A9EF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export default ForwardRef;